<div class="text-info">
  <span class="text-question">{{ "PARENT_REGISTER_DATA.REVIEWING.DID_YOU_KNOW" | translate }}</span>
</div>
<div class="text-info">
  <p class="small-info">{{ "PARENT_REGISTER_DATA.REVIEWING.INFO" | translate }}</p>
</div>